import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";

import MakeSelectionTick from "../../../assets/images/icons/makes_selection_tick.svg";
import { LIST_TAB_MODELS } from "../../NewQuery/EquipmentTab/equipmentQuery";
import * as HomePageTabsAction from "../../NewRedux/HomePageTabs/homepageTabsAction";

export const EquipmentStepper2 = ({ stepperState, setStepperState, setFilterSelectedData, filterSelectedData }) => {
  const dispatch = useDispatch();

  const models = useSelector(state => state.homepageTabSlice.models);

  const allState = useSelector(state => state.homepageTabSlice);

  const [data, setData] = useState([]);

  const [columnCountState] = useState(4);

  const [getTabModelsData,
    { loading: tabModelsDataLoading, error: tabModelsDataError, data: tabModelsData }] = useLazyQuery(LIST_TAB_MODELS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (tabModelsData?.getModelDataForGivenMakes) {
      dispatch(HomePageTabsAction.setTabModelsList(tabModelsData?.getModelDataForGivenMakes));
    }
  }, [tabModelsData, tabModelsDataLoading, tabModelsDataError, dispatch]);
  useEffect(() => {
    let makesIdArray = filterSelectedData.makes.map(value => value.id);
    getTabModelsData({
      variables: { makeIds: makesIdArray },
    });
  }, [filterSelectedData]);

  const toggleModelSelection = (makeDetail, modelDetail) => {
    let selectedModelArray = [...filterSelectedData.models];
    let currentSelectedMakesArray = filterSelectedData.makes.filter((value) => value.id === makeDetail.id);
    let indexOfSelectedModel = selectedModelArray.findIndex((value) => value.id === modelDetail.id);
    if (indexOfSelectedModel !== -1) {
      selectedModelArray.splice(indexOfSelectedModel, 1);
    }
    else {
      selectedModelArray.push({ id: modelDetail.id, name: makeDetail.name + " " + modelDetail.name });
    }

    setFilterSelectedData((preVal) => ({
      ...preVal,
      models: [...selectedModelArray],
    }));
  };

  useEffect(() => {
    if (models) {
      let finalDataArray = [];
      models.map((modelData, index) => {
        let parentArray = [];
        let parentArray2 = [];
        modelData.details.map((modelDetail, modelIndex) => {
          let childArray = [];
          let indexVar = null;
          switch (modelIndex % columnCountState) {
          case 0:
            indexVar = 0;
            break;
          case 1:
            indexVar = 1;
            break;
          case 2:
            indexVar = 2;
            break;
          default:
            indexVar = 3;
          }
          
          if (Array.isArray(parentArray[indexVar])) {
            parentArray[indexVar].push(<div className="modelDivision" onClick={() => toggleModelSelection(modelData.make, modelDetail.model)}>
              <div className={"modelTitleDivision contentUpperDivision d-flex justify-content-center align-items-center "}>
                {modelDetail.model.name}
                {
                  (filterSelectedData.models.some(value => value.id === modelDetail.model.id)) ? <img src={MakeSelectionTick} className="modelTitleDivisionSelectionImage" /> : null
                }

              </div>
              {/* <div className="subModelDivision">
                {
                  modelDetail.subModel.map((subModelValue, subModelIndex) => {
                    return (
                      <div className="subModelTitleDivision d-flex justify-content-center align-items-center contentLowerDivOptions">{subModelValue.name}<img src={MakeSelectionTick} className="subModelTitleDivisionSelectionImage" /></div>
                    );
                  })
                }
              </div> */}
            </div>);
          }
          else {
            childArray.push(<div className="modelDivision" onClick={() => toggleModelSelection(modelData.make, modelDetail.model)}>
              <div className="modelTitleDivision contentUpperDivision d-flex justify-content-center align-items-center">
                {modelDetail.model.name}
                {
                  (filterSelectedData.models.some(value => value.id === modelDetail.model.id)) ? <img src={MakeSelectionTick} className="modelTitleDivisionSelectionImage" /> : null
                }
              </div>
              {/* <div className="subModelDivision">
                {
                  modelDetail.subModel.map((subModelValue, subModelIndex) => {
                    return (
                      <div className="subModelTitleDivision d-flex justify-content-center align-items-center contentLowerDivOptions">{subModelValue.name}<img src={MakeSelectionTick} className="subModelTitleDivisionSelectionImage" /></div>
                    );
                  })
                }
              </div> */}
            </div>);
            parentArray.push(childArray);
          }

        });
        parentArray2.push(<div className="categoryContentDivision my-5">
          <div className="categoryTitleDivision my-5">
            <span>{modelData.make.name}</span>
          </div>
          <div className="modelSelectionDivision d-flex flex-wrap">{parentArray.map((value) => (
            <div className='w-25 modelContentColumn'>{value}</div>
          ))}</div></div>);
        finalDataArray.push(parentArray2);
      },
      );
      setData(finalDataArray);
    }

  }, [models, filterSelectedData.models]);
  return (
    <div id="makesSelectionDivision" className="makesSelectionDivision">
      <div id="makesUpperDivision" className="d-flex justify-content-around mb-5 row">
        <Link to="/search-result" className="viewAllMakesButton">View All Models</Link>
      </div>
      <div className="makeTabDividerDivision text-center my-5">
        OR
      </div>
      <div id="makesLowerDivision">
        <div className="makesLowerTopDivision mb-5">
          <div className="text-center makeBottomDivisionTitle">
            Choose a Model
          </div>
          <div className="text-center makeBottomDivisionSubtitle row">
            <div className="col-3"></div>
            <div className="col-6 text-center">
              Select a model below to continue
            </div>
            {/* {
              filterSelectedData.makes.length ? <div className="col-3 d-flex justify-content-end makesSelectedCountDivision">
                {
                  filterSelectedData.makes.length
                } Makes Selected
              </div> : null
            } */}
          </div>
          <div className='categoryDivision'>
            {
              data.map((value) => {
                return value;
              })
            }
          </div>
        </div>

      </div>
    </div>
  );
};
